import React, { useState, useEffect } from "react";
import { ModalDisputeContainer, ProfileImage } from "./ModalDisputeStyled";
import { FormattedMessage, useIntl } from 'react-intl';

import avatar from './../../utils/images/avatar_fluincr.png';
import check from './../../utils/images/check_circle_darker.svg';
import star from './../../utils/images/star.svg';
import upload from './../../utils/images/upload.svg';
import arrowBack from './../../utils/images/arrow_back.svg';
import close from './../../utils/images/close_circle.svg';
import deleteIcon from './../../utils/images/delete_grey.svg';

import { fill, formatNumber, getBase64 } from "../../services/generalSevices";
import { countdown, formatDateLocal, toUTCString } from "../../services/dateServices";
import { useContext } from "react";
import { UserContext } from "../../context/userContext";
import { postFileBase64 } from "../../api/fileApi";
import { patchCollaboration, postDispute, putCollaborationStatus } from "../../api/collaborationApi";
import { useNavigate, useParams } from 'react-router-dom';
import Spinner from "../Spinner/Spinner";
import { CurrencyContext } from "../../context/currencyContext";
import { getConvertCurrency } from "../../api/exchangeApi";
import ChargingSpinner from "../ChargingSpinner/ChargingSpinner";

export default function ModalDispute({ setShowDispute, collaborationDetails, setCollaborationStatus, setShowReceivedDispute }) {

    const { idCollaboration } = useParams();
    const { userToken, userType, name, lastName, companyName, imageProfile, uniqueName, account } = useContext(UserContext);
    const { currency } = useContext(CurrencyContext);

    const [disputeDetail, setDisputeDetail] = useState('');

    const [base64File, setBase64File] = useState('');
    const [isLoading, setIsLoading] = useState(false);

    const [auxProductPrice, setAuxProductPrice] = useState(null);

    const [file, setFile] = useState(null);
    const [showSmallSpinner, setShowSmallSpinner] = useState(false);

    useEffect(() => {
        const auxCurrency = currency.symbol;
        getConvertCurrency({ amount: collaborationDetails?.product?.price?.USD }).then((amountResponse) => {
            //setAuxProductPrice(amountResponse[auxCurrency].toFixed(0))
            setAuxProductPrice(amountResponse[auxCurrency].toFixed(2))
        })
    }, [currency])

    const showSpinner = () => {
        setShowSmallSpinner(true);
        setTimeout(() => {
            setShowSmallSpinner(false);
        }, 3000);
    }

    const sendDispute = () => {
        setIsLoading(true)

        const disputeBody = {
            description: disputeDetail,
            file: "",
            type: "",
            idColaboration: idCollaboration
        }

        if (userType === 'influencer') {
            disputeBody.type = 'INFLUENCER'
        } else {
            disputeBody.type = 'COMPANY'
        }

        if (base64File !== '') {
            const fileBody = {
                base64File: base64File.base64.split(',')[1],
                formatFile: base64File.type,
                address: ""
            }
            if (userType === 'influencer') {
                fileBody.address = `company/${account}/dispute`
            } else {
                fileBody.address = `fluincr/${account}/dispute`
            }

            postFileBase64({ body: fileBody, token: userToken }).then((responseFile) => {
                if (responseFile.length > 0) {
                    disputeBody.file = responseFile

                    postDispute({ disputeBody: disputeBody, token: userToken }).then((response) => {
                        const collaborationBody = {

                        }
                        if (userType === 'influencer') {
                            collaborationBody.readcompany = false
                        } else {
                            collaborationBody.readinfluencer = false
                        }

                        if (response.status === 201) {
                            putCollaborationStatus({ collaborationId: idCollaboration, newStatus: 4, token: userToken }).then((responseStatus) => {
                                setCollaborationStatus(4)
                                setShowReceivedDispute(true);
                                setShowDispute(false)
                                if (responseStatus.status === 200) {
                                    patchCollaboration({ collaborationId: idCollaboration, collaborationBody: collaborationBody }).then((responseRead) => {
                                        setIsLoading(false)
                                    })
                                } else {
                                    setIsLoading(false)
                                }
                            })
                        } else {
                            setIsLoading(false)
                        }

                    })
                }
            })
        } else {
            postDispute({ disputeBody: disputeBody, token: userToken }).then((response) => {
                const collaborationBody = {

                }
                if (userType === 'influencer') {
                    collaborationBody.readcompany = false
                } else {
                    collaborationBody.readinfluencer = false
                }

                if (response.status === 201) {

                    putCollaborationStatus({ collaborationId: idCollaboration, newStatus: 4, token: userToken }).then((responseStatus) => {
                        setCollaborationStatus(4)
                        setShowReceivedDispute(true);
                        setShowDispute(false)
                        if (responseStatus.status === 200) {
                            patchCollaboration({ collaborationId: idCollaboration, collaborationBody: collaborationBody }).then((responseRead) => {
                                setIsLoading(false)
                            })
                        } else {
                            setIsLoading(false)
                        }
                    })
                } else {
                    setIsLoading(false)
                }

            })
        }
    }

    return (
        <ModalDisputeContainer>
            <div className="disputeContainer">

                <img src={close} alt="close" className="close" onClick={() => { setShowDispute(false) }} />

                <div className="goBack" onClick={() => setShowDispute(false)} >
                    <img src={arrowBack} alt="back" className="backIcon" />
                    <p className="backText" ><FormattedMessage id="go_back" defaultMessage="ir atrás" /></p>
                </div>

                <h3 className="title"><FormattedMessage id="collaboration_details_text_15" defaultMessage="Detalle del convenio" /></h3>
                <div className="orderDetails">
                    <p className="order"><FormattedMessage id="collaboration_details_text_1" defaultMessage="Orden" /> #{(collaborationDetails?.id !== undefined) && fill(collaborationDetails?.id, 8)}</p>
                    {/* <p className="date">{formatDateLocal(toUTCString(new Date(collaborationDetails?.creation)))}</p> */}

                    {(collaborationDetails?.creation !== undefined) && (<p className="date">{formatDateLocal(toUTCString(new Date(collaborationDetails?.creation)))}</p>)}
                </div>

                <div className="disputeBody">
                    <section>
                        <div className="influencerDate">

                            <p className="influencerName"><FormattedMessage id="collaboration_details_text_2" defaultMessage="Colaboración con" /> {(userType === 'influencer') ? (<span className="name">{collaborationDetails?.company?.nameCompany}</span>) : (<span className="name">{collaborationDetails?.influincr?.givenName}</span>)}</p>

                            {(userType === 'influencer') ? (<ProfileImage image={(collaborationDetails?.company?.imageProfile !== '' && collaborationDetails?.company?.imageProfile !== null) ? collaborationDetails?.company?.imageProfile : avatar} />) : (<ProfileImage image={(collaborationDetails?.influincr?.imageProfile !== '' && collaborationDetails?.influincr?.imageProfile !== null) ? collaborationDetails?.influincr?.imageProfile : avatar} />)}

                            {((userType === 'influencer') && (collaborationDetails?.influincr?.attributes?.verified)) && (<img src={check} alt="check" className="check" />)}

                            {((userType === 'company') && (collaborationDetails?.company?.attributes?.verified)) && (<img src={check} alt="check" className="check" />)}

                            {(userType === 'company') && (<div className="rating">
                                <p className="score">{(collaborationDetails?.influincr?.rating === null) ? 'N/R' : collaborationDetails?.influincr?.rating}</p>
                                <img src={star} alt="star" className="star" />
                            </div>)}

                            {(userType === 'influencer') && (<div className="rating">
                                <p className="score">{(collaborationDetails?.company?.rating === null) ? 'N/R' : collaborationDetails?.company?.rating}</p>
                                <img src={star} alt="star" className="star" />
                            </div>)}

                        </div>
                        <div className="productInformation">
                            <div className="productImage" style={{ backgroundImage: `url(${collaborationDetails?.product?.image})` }}>

                            </div>
                            <div className="description">
                                <p className="productName">{collaborationDetails?.product?.name}</p>
                                <p className="productPrice">$ {formatNumber(auxProductPrice)}</p>
                                <p className="productDescription">{collaborationDetails.product?.description}</p>
                            </div>
                        </div>
                        {(collaborationDetails?.comment !== '') && (<>
                            <p className="commentsTitle"><FormattedMessage id="collaboration_details_text_6" defaultMessage="Comentarios (ver detalladamente)" /></p>
                            <p className="comments">{collaborationDetails?.comment}</p>
                        </>)}
                        {(collaborationDetails.document !== '') && (
                            <a href={collaborationDetails.document} download={collaborationDetails.document} >
                                <p className="file"><FormattedMessage id="collaboration_details_text_12" defaultMessage="Collaborationfile" /></p>
                            </a>)}
                    </section>
                    <section>
                        <div className="influencerData">
                            <h3><FormattedMessage id="modal_dispute_text_1" defaultMessage="Hola, " /><span className="name">{(userType === 'influencer') ? (name) : (companyName)}</span></h3>
                            <ProfileImage image={(imageProfile !== '' && imageProfile !== null) ? imageProfile : avatar} />
                        </div>

                        <p className="text1"><FormattedMessage id="modal_dispute_text_2" defaultMessage="Lamentamos escuchar acerca de tu preocupación." /></p>
                        <p className="text2"><FormattedMessage id="modal_dispute_text_3" defaultMessage="Antes de iniciar una disputa, primero debes intentar comunicarte y resolver el problema con la otra parte, dentro de la ventana de disputa." /></p>
                        <p className="text3"><FormattedMessage id="modal_dispute_text_4" defaultMessage="Cuéntanos sobre tu disputa." /></p>
                        <p className="text4"><FormattedMessage id="modal_dispute_text_5" defaultMessage="¿Cómo trataste de resolver el problema con la otra parte?" /></p>
                        <textarea name="" id="" cols="30" rows="10" value={disputeDetail} onChange={(event) => { setDisputeDetail(event.target.value) }}></textarea>

                        <div className="uploadFile">

                            {/* <label htmlFor="dispute-file-input" className="fileLabel">
                                 <img src={upload} alt="upload" className="uploadIcon" /> 
                                <span>{fileName}</span>
                                <p><FormattedMessage id="modal_dispute_text_6" defaultMessage="Subir archivo" /></p>
                            </label> */}

                            {(base64File === '') && (
                                <label htmlFor="dispute-file-input" className="fileLabel">
                                    <img src={upload} alt="upload" className="uploadIcon" />
                                    <p><FormattedMessage id="modal_dispute_text_6" defaultMessage="Subir archivo" /></p>
                                </label>
                            )}

                            {(showSmallSpinner) && (<div className="chargingContainer">
                                <ChargingSpinner />
                            </div>)}

                            {(base64File !== '' && showSmallSpinner === false) && (
                                <> <img src={deleteIcon} alt="upload" className="deleteIcon" onClick={() => {
                                    setBase64File('')
                                    setFile(null)
                                }} />
                                    <span className="fileName">{file.name}</span>
                                </>
                            )}

                            <input type="file" id="dispute-file-input"
                                accept=".pdf, .txt, application/pdf, .doc, .docx, application/msword, .xls,.xlsx, application/vnd.ms-excel, .ppt, .pptx, application/vnd.ms-powerpoint, text/plain,.png, .jpg, .jpeg, image/png, image/jpg" onChange={(e) => {
                                    if (e.target.files[0] !== undefined) {
                                        setFile(e.target.files[0])
                                        getBase64({ file: e.target.files[0] }).then((data) => {
                                            setBase64File({ base64: data, name: e.target.files[0].name, type: e.target.files[0].type.split('/')[1] });
                                        }
                                        );
                                        showSpinner()
                                    }
                                }} />
                            {/* <img src={upload} alt="upload" /> */}

                        </div>
                        <p><FormattedMessage id="modal_dispute_text_7" defaultMessage="Al crear una disputa, entendemos que la colaboración  en su totalidad se suspenderá por el momento hasta que  la investigación sea completada y resuelta por parte de Fluincr." /></p>
                        <button className="sendDisputeButton" onClick={sendDispute}><FormattedMessage id="modal_dispute_button" defaultMessage="Enviar disputa" /></button>
                    </section>

                </div>


            </div>
            {(isLoading) && (<Spinner />)}
        </ModalDisputeContainer>
    )
}